import { render, staticRenderFns } from "./BorrowingPage.vue?vue&type=template&id=04150cee&scoped=true&"
import script from "./BorrowingPage.vue?vue&type=script&lang=ts&"
export * from "./BorrowingPage.vue?vue&type=script&lang=ts&"
import style0 from "./BorrowingPage.vue?vue&type=style&index=0&id=04150cee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04150cee",
  null
  
)

export default component.exports